import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import * as Dictionary from '../../Models/Dictionary';
import { EnumTypes as PageEnumTypes } from '../../Models/EnumTypes/PageEnumTypes';
import LanguageSwitcher from './../Layout/LanguageSwitcher/LanguageSwitcher';

import Login from './Login/_Login';
import Register from './_Register';
import RestartPassword from './ResetPassword/_RestartPassword';
import ResetPasswordConfirm from './ResetPasswordConfirm/_ResetPasswordConfirm';
import ActivateUserComplete from './ActivateUser/ActivateUserComplete';

class UserSigningRoot extends React.Component<any, {}> {
    public render() {
        return (
            <div className="signingPage">
                <div className="login">
                    <div className="login__language-switcher">
                        <LanguageSwitcher type="LOGIN" />
                    </div>
                    <Switch>
                        <Route exact path={Dictionary.PageUrl.get(PageEnumTypes.Page.LOGIN)} component={Login} />
                        <Route exact path={Dictionary.PageUrl.get(PageEnumTypes.Page.REGISTER)} component={Register} />
                        <Route exact path={Dictionary.PageUrl.get(PageEnumTypes.Page.FORGOT_PASSWORD)} component={RestartPassword} />
                        <Route exact path={Dictionary.PageUrl.get(PageEnumTypes.Page.FORGOT_PASSWORD_CONFIRM)} component={ResetPasswordConfirm} />
                        <Route exact path={Dictionary.PageUrl.get(PageEnumTypes.Page.ACTIVATE_USER_ACCOUNT_COMPLETE)} component={ActivateUserComplete} />
                        <Route
                            component={() => {
                                this.props.history.push('/');
                                return null;
                            }}
                        />
                    </Switch>
                </div>
            </div>
        );
    }
}

export default UserSigningRoot;



// WEBPACK FOOTER //
// ./src/components/UserSigning/_UserSigningRoot.tsx